export default {
    apiUrl: 'https://localhost:44307/api',
    ACCESS_TOKEN: 'dcsvrrapp_access_token',
    REFRESH_TOKEN: 'dcsvrrapp_refresh_token',
    ACCESS_TOKEN_PROP: 'accessToken',
    REFRESH_TOKEN_PROP: 'refreshToken',
    PROVIDER_LIST_STATE: 'PROVIDER_LIST_STATE',
    EMPLOYERSPOTLIGHTPRESENTION_LIST_STATE: 'EMPLOYER_SPOTLIGHT_PRESENTION_LIST_STATE',
    RSA_SPECIALLIST_MEETING_REQUEST_LIST_STATE: 'RSA_SPECIALLIST_MEETING_REQUEST_LIST_STATE',
    PUBLIC_EMPLOYERSPOTLIGHTPRESENTION_LIST_STATE: 'PUBLIC_EMPLOYER_SPOTLIGHT_PRESENTION_LIST_STATE',
    PUBLIC_PROVIDER_DETAIL_STATE: 'PUBLIC_PROVIDER_DETAIL_STATE',
    WORKSHOP_LIST_STATE:'WORKSHOP_LIST_STATE',
    CASASTESTING_LIST_STATE:'CASASTESTING_LIST_STATE',
    USER_LIST_STATE:'USER_LIST_STATE'
  };
  